// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"30df622f","305":"46da653d","311":"eaf07195","379":"589bb164","482":"6b92bf17","545":"d5f2a6e6","921":"3f504793","975":"7c84e04c","997":"dc3a3e5c"}[chunkId] + ".chunk.js";
};